export enum ProfessionalCaregiverInviteFormType {
  SystemAdministrator = 'system-administrator',
  ProfessionalCaregiver_Administrator = 'professional-caregiver_administrator',
  ProfessionalCaregiver_Manager = 'professional-caregiver_manager',
}
